import React, { useEffect, useState } from 'react';
import api from '../api';

const OUTPUT_TYPES = ['all', 'image', 'audio', 'video', 'speech'];

const ModelSelector = ({ onModelSelect }) => {
  const [models, setModels] = useState([]);
  const [selectedModel, setSelectedModel] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');

  useEffect(() => {
    const fetchModels = async () => {
      try {
        // Check URL for showTest parameter
        const urlParams = new URLSearchParams(window.location.search);
        const showTest = urlParams.get('showTest') === 'true';
        
        // Fetch models with optional test inclusion
        let url = '/api/models/active';
        if (showTest) {
          url += '?includeTest=true';
        }

        const response = await api.get(url);
        setModels(response.data);
      } catch (error) {
        console.error('Error fetching models:', error);
      }
    };
    fetchModels();
  }, []);

  const handleModelChange = (e) => {
    const modelId = e.target.value;
    setSelectedModel(modelId);
    onModelSelect(modelId);
  };

  // Filter models by output_type
  const filteredModels = typeFilter === 'all'
    ? models
    : models.filter((model) => model.output_type === typeFilter);

  // Check if we're showing test models
  const showTest = new URLSearchParams(window.location.search).get('showTest') === 'true';

  return (
    <div>
      {showTest && (
        <div style={{ 
          marginBottom: 8, 
          padding: '8px 12px', 
          backgroundColor: '#fff3cd', 
          border: '1px solid #ffeaa7', 
          borderRadius: 4, 
          fontSize: '0.9rem',
          color: '#856404'
        }}>
          🧪 <strong>Test Mode:</strong> Showing test models (remove ?showTest=true from URL to hide)
        </div>
      )}
      <div style={{ marginBottom: 8 }}>
        {OUTPUT_TYPES.map((type) => (
          <button
            key={type}
            type="button"
            onClick={() => setTypeFilter(type)}
            style={{
              marginRight: 8,
              padding: '6px 14px',
              borderRadius: 4,
              border: typeFilter === type ? '2px solid #007bff' : '1px solid #ccc',
              background: typeFilter === type ? '#e6f0ff' : '#fff',
              color: typeFilter === type ? '#007bff' : '#333',
              fontWeight: typeFilter === type ? 'bold' : 'normal',
              cursor: 'pointer',
            }}
          >
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </button>
        ))}
      </div>
      <select value={selectedModel} onChange={handleModelChange}>
        <option value="">Select a model</option>
        {filteredModels.map((model) => (
          <option key={model.id} value={model.id}>
            {model.name}
            {model.status === 'test' && ' 🧪'}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ModelSelector;
